import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./styles/globals.css";
import { BrowserRouter } from "react-router-dom";
import { AdaptivityProvider } from "./styles/adaptivity";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AdaptivityProvider>
        <App />
      </AdaptivityProvider>
    </BrowserRouter>
  </React.StrictMode>
);
reportWebVitals();
